/*
 * Vehicle steps -> the product's own options, per product kind (el.kind, from the block settings):
 * seat covers click the hidden Seat Set radio of the chosen card; car covers keep the Color swatches to what
 * the vehicle row sells and click the hidden Size radio of that colour's price tier; floor mats click the hidden
 * Floor Mat Set and Size radios. Radio clicks only, as for seats, so price, variant id and cart stay Shrine's.
 * Loaded after seatfit-vehicle-steps-shrine.js and before seatfit-vehicle-steps-sync.js.
 */
(function () {
  'use strict';
  if (window.SeatFitStepsOptions) return;
  var B = window.SeatFitShrine;

  function slug(v) { return window.SeatFit ? window.SeatFit.slugify(v) : String(v == null ? '' : v).toLowerCase(); }
  // Anything but a car cover or floor mat block is a seat block, as before kinds existed.
  function kindOf(el) { return el.kind === 'cover' || el.kind === 'mat' ? el.kind : 'seat'; }

  // Option groups the shopper never sees, because the steps choose them.
  function prepare(el) {
    var shop = el.shop;
    var kind = kindOf(el);
    var names = kind === 'cover' ? [shop.sizeName] : kind === 'mat' ? [shop.setName, shop.sizeName] : [shop.setName];
    names.forEach(function (n) { B.hideGroup(shop, n); });
  }

  // Our radio clicks fire Shrine's change event like a shopper's; the flag lets afterVariant tell them apart.
  function choose(el, name, value) {
    var was = el.syncing;
    el.syncing = true;
    try { return B.chooseOption(el.shop, name, value); } finally { el.syncing = was; }
  }

  // Covers: the checked colour is not sold for the chosen row -> check the first swatch (page order) it sells.
  // true = picks.color changed, so the caller reads the rules again.
  function fixColor(el, picks) {
    var sel = el.sel;
    if (kindOf(el) !== 'cover' || !sel || !sel.row || sel.color || !(sel.colors || []).length) return false;
    var first = B.values(el.shop, el.shop.colorName).filter(function (v) { return sel.colors.indexOf(slug(v)) >= 0; })[0];
    if (first == null || !choose(el, el.shop.colorName, first)) return false;
    picks.color = slug(first);
    return true;
  }

  // Rows of the vehicle-year that still fit the steps answered so far; a row without a step fits any answer there.
  function inPlay(rows, steps) {
    return rows.filter(function (r) {
      return steps.every(function (s) {
        if (s.value == null) return true;
        var own = (r.st || []).filter(function (p) { return p && slug(p[0]) === slug(s.name); })[0];
        return !own || slug(own[1]) === slug(s.value);
      });
    });
  }

  function matSet(ctx, r) {
    var p = (r.st || []).filter(function (x) { return x && window.SeatFit.isOptionStep(ctx, x[0]); })[0];
    return p ? p[1] : '';
  }

  // An open selection still shows a vehicle price, the one the reference page shows before the last steps
  // (measured 29/09: mats show the Full Set price — Camry $179.95, F-150 $199.95 before Cab, then $159.95 once
  // Regular Cab leaves only Front sets; the product's first variant would say $159.95 everywhere): mats = the
  // cheapest Full Set among the rows still in play, else the cheapest Front, else any set; covers = the chosen
  // colour on the first such row. The Buy button stays locked meanwhile, so this never decides what is bought.
  var PREVIEW_SETS = ['full-set', 'front'];
  function preview(el, sel) {
    var ctx = el.ctx;
    var kind = kindOf(el);
    if (el.loading || !ctx || ctx.status !== 'ok' || !ctx.tiers || !sel || kind === 'seat') return;
    var rows = inPlay(ctx.rows || [], sel.steps || []);
    var options = {};
    if (kind === 'mat') {
      var priced = rows.filter(function (r) { return r.t && ctx.tiers[r.t] && matSet(ctx, r); });
      var pool = priced;
      for (var i = 0; i < PREVIEW_SETS.length; i++) {
        var same = priced.filter(function (r) { return slug(matSet(ctx, r)) === PREVIEW_SETS[i]; });
        if (same.length) { pool = same; break; }
      }
      var best = pool.sort(function (a, b) { return ctx.tiers[a.t][0] - ctx.tiers[b.t][0]; })[0];
      if (!best) return;
      options[el.shop.setName] = matSet(ctx, best);
      options[el.shop.sizeName] = best.t;
    } else {
      var tier = rows[0] && (rows[0].c || {})[slug(B.checked(el.shop, el.shop.colorName))];
      if (!tier) return;
      options[el.shop.sizeName] = tier;
    }
    Object.keys(options).forEach(function (n) { choose(el, n, options[n]); });
  }

  // After the rules: select on the product what the selection buys. false = the product lacks a value the data
  // sells, so the caller keeps the Buy button locked (never a different set, size or colour in the cart).
  function select(el) {
    var sf = window.SeatFit;
    var sel = el.sel;
    var kind = kindOf(el);
    if (kind === 'seat') {
      if (!sel || !sel.set || choose(el, el.shop.setName, sf.SET_VALUES[sel.set])) return true;
      console.warn('[SeatFit] product has no Seat Set value for', sel.set);
      return false;
    }
    // Before the row is known every colour stays on offer (the reference shows all of them too); a load in
    // progress keeps the current swatches, so a year change does not flash the hidden ones.
    var sold = sel && sel.row && (sel.colors || []).length ? sel.colors : null;
    if (kind === 'cover' && !el.loading) B.showValues(el.shop, el.shop.colorName, sold);
    if (!sel || !sel.complete) {
      preview(el, sel);
      return true;
    }
    var offer = sf.offer(el.ctx, sel, { set: el.shop.setName, size: el.shop.sizeName });
    var names = offer ? Object.keys(offer.options) : [];
    var ok = names.length > 0 && names.every(function (n) { return choose(el, n, offer.options[n]); });
    if (!ok) console.warn('[SeatFit] product has no variant for', kind, sel.row && sel.row.k, offer && offer.options);
    return ok;
  }

  window.SeatFitStepsOptions = { prepare: prepare, choose: choose, fixColor: fixColor, select: select };
})();
